(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["product-recommendation"]) return;
  try {
    
	const productRecommendationsSection = document.querySelector('.product-recommendations');
  const url = productRecommendationsSection.dataset.url;

	fetch(url)
		.then(response => response.text())
		.then(text => {
			const html = document.createElement('div');
			html.innerHTML = text;
			const recommendations = html.querySelector('.product-recommendations');

			if (recommendations && recommendations.innerHTML.trim().length) {
				productRecommendationsSection.innerHTML = recommendations.innerHTML;
				initFlexButton();
			}
		})
		.catch(e => {
			console.error(e);
		});

  } catch(e) { console.error(e); }
})();
})();
